import { cr } from "fire-wind-water";

// import {Checkbox} from './checkbox';
// import {Desc} from './desc';
// import {Field} from './field';
// import {File} from './file';
// import {Line} from './line';
// import {List} from './list';
// import {Policy} from './policy';
// import {Select} from './select';
// import {Text} from './text';
// import {DateTime} from './time';

export function updateDirty(list): { [label: string]: unknown } {
  let isVerify = true;
  const field = [];
  let verificationCode = false;
  let scenesKey = "";
  cr.each(list, (d) => {
    const v: { [label: string]: string } = {
      fieldName: d.fieldName,
      value: d.value,
    };
    if (d.fieldType === "LIST") {
      v.otherValue = d.otherValue;
    }

    field.push(v);

    d.dirty = true;
    d.sensitivDirty = true;
    if (d.isSendSms == 1) {
      d.verificationCodeDirty = true;
      verificationCode = d.verificationCode;
      scenesKey = d.scenesKey;
    }
    if (d.fieldType === "LIST" && d.listOptionType === "CUSTOM") {
      cr.each(d.listOptions, (m) => {
        m.dirty = true;
      });
    }
    if (d.invalid) {
      isVerify = false;
    }
  });
  return {
    isVerify: isVerify,
    field: field,
    verificationCode: verificationCode,
    scenesKey: scenesKey,
  };
}

export * from "./checkbox";
export * from "./desc";
export * from "./field";
export * from "./file";
export * from "./line";
export * from "./list";
export * from "./policy";
export * from "./customPolicy";
export * from "./select";
export * from "./text";
export * from "./time";
export * from "./radio";
export * from "./checkbox-select";
export * from "./cascader";
